<template>
  <div>
    <div v-for="result in data.detailsByType" :key="result.type" class="table-container">
      <div class="header">{{ getTitle(result.type) }} ({{ result.packages.length }})</div>
      <table class="table hide-medium" border="0" cellspacing="0" cellpadding="0">
        <thead class="table-header">
          <tr>
            <th class="table-header-item">{{ $t('package') }}</th>
            <th class="table-header-item">{{ $t('legalPersonBilling') }}</th>
            <th class="table-header-item">{{ $t('physicalPeopleBilling') }}</th>
            <th class="table-header-item">{{ $t('noBilling') }}</th>
            <th class="table-header-item">{{ $t('total') }}</th>
          </tr>
        </thead>
        <tbody class="table-content">
          <tr v-for="(item, index) in result.packages" :key="index + item.toString() + result.type" class="table-line">
            <td class="table-item">
              <div class="item name">{{ item.name }}</div>
            </td>
            <td class="table-item">
              <div class="item">{{ $utils.splitStringBySegmentLength(item.completionLevel3Price) }} €</div>
              <div class="item">{{ item.completionLevel3CompanyCount }} {{ $t('enterprise(s)') }}</div>
            </td>
            <td class="table-item">
              <div class="item">{{ $utils.splitStringBySegmentLength(item.completionLevel2Price) }} €</div>
              <div class="item">{{ item.completionLevel2CompanyCount }} {{ $t('enterprise(s)') }}</div>
            </td>
            <td class="table-item">
              <div class="item">{{ $utils.splitStringBySegmentLength(item.completionLevel1Price) }} €</div>
              <div class="item">{{ item.completionLevel1CompanyCount }} {{ $t('enterprise(s)') }}</div>
            </td>
            <td class="table-item">
              <div class="item">{{ $utils.splitStringBySegmentLength(item.totalPrice) }} €</div>
              <div class="item">{{ item.totalCount }} {{ $t('enterprise(s)') }}</div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="table-container show-medium">
        <div v-for="(item, index) in result.packages" :key="index + item.toString() + result.type" class="table-line">
          <div class="line column">
            <div class="line-content title">{{ $t('package') }}</div>
            <div class="line-content">
              <div class="item">{{ item.name }}</div>
            </div>
          </div>

          <div class="line column">
            <div class="line-content title">
              {{ $t('legalPersonBilling') }}
            </div>
            <div class="line-content">
              <div class="item">{{ $utils.splitStringBySegmentLength(item.completionLevel3Price) }} €</div>
            </div>
            <div class="line-content">
              <div class="item">{{ item.completionLevel3CompanyCount }} {{ $t('enterprise(s)') }}</div>
            </div>
          </div>

          <div class="line column">
            <div class="line-content title">
              {{ $t('physicalPeopleBilling') }}
            </div>
            <div class="line-content">
              <div class="item">{{ $utils.splitStringBySegmentLength(item.completionLevel2Price) }} €</div>
            </div>
            <div class="line-content">
              <div class="item">{{ item.completionLevel2CompanyCount }} {{ $t('enterprise(s)') }}</div>
            </div>
          </div>

          <div class="line column">
            <div class="line-content title">
              {{ $t('noBilling') }}
            </div>
            <div class="line-content">
              <div class="item">{{ $utils.splitStringBySegmentLength(item.completionLevel1Price) }} €</div>
            </div>
            <div class="line-content">
              <div class="item">{{ item.completionLevel1CompanyCount }} {{ $t('enterprise(s)') }}</div>
            </div>
          </div>

          <div class="line column">
            <div class="line-content title">
              {{ $t('total') }}
            </div>
            <div class="line-content">
              <div class="item">{{ $utils.splitStringBySegmentLength(item.totalPrice) }} €</div>
            </div>
            <div class="line-content">
              <div class="item">{{ item.totalCount }} {{ $t('enterprise(s)') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getTitle(type) {
      switch (type) {
        case 1:
          return this.$t('newMonitoring');
        case 2:
          return this.$t('updatedMonitoring');
        case 3:
          return this.$t('renewedMonitoring');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.table-container .header {
  margin: 60px 0 25px 0;
  font-size: 20px;
  font-weight: 500;
  color: colors.$darkblue-color;
}
.table-container .table {
  overflow: hidden;

  .table-content .table-line .table-item {
    background: colors.$white-color;

    .item {
      color: colors.$grey-color;
      width: 100%;
      margin-bottom: 4px;

      &.name {
        color: colors.$lightblue-color;
      }
    }
  }
}

@media only screen and (max-width: responsive.$layout-breakpoint-medium) {
  .table-container {
    width: 100%;

    .table-line {
      width: 100%;
      // height: 192px;
      margin: 12px 0;
      display: flex;
      flex-direction: column;

      margin-bottom: 0;

      background: colors.$unread-table-color;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 4px;

      &.read {
        background: rgba(colors.$lightgrey-color, 0.2);

        .item {
          opacity: 0.7;
        }
      }

      .line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-grow: 1;

        margin: 12px 0;

        &.right {
          justify-content: flex-end;
        }

        &.column {
          flex-direction: column;
          justify-content: space-evenly;
          align-items: flex-start;
        }

        .line-content {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .item {
            display: flex;
            align-items: center;
          }

          &.read-indication {
            align-self: flex-end;
          }

          &.title {
            font-weight: 500;
            color: colors.$grey-color;
            line-height: 16px;
            font-size: 14px;
            margin-bottom: 8px;
          }

          &.label,
          &.date {
            font-weight: 500;
            color: colors.$black-color;
          }

          &.date,
          .internal-id {
            font-size: 12px;
          }

          &.label {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
